// extracted by mini-css-extract-plugin
export default {"brandPromo":"vG-z","carousel":"wG-z"};